import { Button } from '@creditornot/cb-button';
import { FormRow } from '@creditornot/cb-form';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import { Input } from '@creditornot/cb-input';
import { ModalFooter, ModalHeader } from '@creditornot/cb-modal';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';

type ModalProps = {
  userName: string;
  isOpen: boolean;
  onClose: () => void;
};

const StyledModal = styled(WoltModal)`
  background: ${cssThemedValue('surfaceMain')};
  width: 100%;
  max-width: 640px;
  color: ${cssThemedValue('textPrimary')};
`;

const CloseButton = styled(Button).attrs({
  variant: 'lightBlue',
  size: 'small',
})``;

const StyledFooter = styled(ModalFooter)`
  justify-content: flex-end;
`;

const ShowSftpUsernameModal = ({ onClose, isOpen, userName }: ModalProps) => {
  const intl = useIntl();

  return (
    <StyledModal isOpen={isOpen}>
      <ModalHeader onCloseClick={onClose}>SFTP Credentials</ModalHeader>
      <FormRow horizontalPadding label={intl.formatMessage({ id: 'merchant-integrations.host' })} labelAlign="center">
        <Input value={process.env.MERCHANT_INTEGRATIONS_SFTP_HOST} readOnly />
      </FormRow>
      <FormRow
        horizontalPadding
        label={intl.formatMessage({ id: 'merchant-integrations.username' })}
        labelAlign="center"
      >
        <Input value={userName} readOnly />
      </FormRow>
      <StyledFooter>
        <CloseButton onClick={onClose}>
          <FormattedMessage id="state.done" />
        </CloseButton>
      </StyledFooter>
    </StyledModal>
  );
};

export default ShowSftpUsernameModal;
